import { useState } from "react";
import { Button, CircularProgress } from "@mui/material";

const LoadingButton = ({ children, loading, onClick, ...otherProps }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async (e) => {
    setIsLoading(true);

    try {
      await onClick(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      onClick={handleClick}
      disabled={isLoading || loading}
      {...otherProps}
    >
      {isLoading || loading ? <CircularProgress size={24} color="inherit" /> : children}
    </Button>
  );
};

export default LoadingButton;
